import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbSidemenu } from '@celebration/design-system/dist/lib/side-menu';

export default createComponent({
    react: React,
    elementClass: ClbSidemenu,
    tagName: ClbSidemenu.tagName,
    events: ClbSidemenu.events,
});
